import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins


export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {   
    this.renderChart({
      labels: this.chartData.labels,
      datasets: this.chartData.datasets,
    }, this.options)    
  },
  watch: {
    "chartData.datasets": function() {
      
      this.renderChart({
        labels: this.chartData.labels,
        datasets: this.chartData.datasets,
      }, this.options)
    }
  },
}